import {http} from '@/utils';

export type GetLeaderboardParams = {
  cycleNum?: number;
};

export type LeaderboardItem = {
  id: number;
  ranking: number;
  fissionUserId: number;
  userName: string;
  userAvatar: string;
  inviteTotalCount: number;
  bonusAmount: number;
  status: number;
  createTime: string;
};

export type GetLeaderboardResponse = {
  rankingList: LeaderboardItem[];
  currentCycle: number;
  jackpot: number;
  cycleEndDate: number;
  cycleStartDate: number;
};

export type GetMyRankingParams = {
  cycleNum?: number;
};

export type GetMyRankingResponse = {
  id: number;
  ranking: number;
  fissionUserId: number;
  userName: string;
  userAvatar: string;
  inviteTotalCount: number;
  bonusAmount: number;
  status: number;
  currentCycle: number;
  createTime: string;
  hasRanking: boolean;
};

export async function getLeaderboard(params?: GetLeaderboardParams) {
  try {
    return await http.get<GetLeaderboardParams, GetLeaderboardResponse>(
      '/app/activity/fission/leaderboard',
      {
        params,
      },
    );
  } catch (err) {
    return {
      rankingList: [],
      currentCycle: 0,
      jackpot: 0.0,
      cycleEndDate: 0,
      cycleStartDate: 0,
    } as GetLeaderboardResponse;
  }
}

export async function getMyRanking(params?: GetMyRankingParams) {
  try {
    return await http.get<GetMyRankingParams, GetMyRankingResponse>(
      '/app/activity/fission/myRanking',
      {
        params,
      },
    );
  } catch (err) {
    return {
      id: 0,
      ranking: 0,
      fissionUserId: 0,
      userName: '',
      userAvatar: '',
      inviteTotalCount: 0,
      bonusAmount: 0.0,
      status: 0,
      currentCycle: 0,
      createTime: '',
      hasRanking: false,
    } as GetMyRankingResponse;
  }
}

export async function getYesterdayReward() {
  const res = await http.get<
    any,
    {
      bonusAmount: number;
      currentCycle: number;
      fissionUserId: number;
      hasRanking: false;
      inviteTotalCount: number;
      ranking: number;
      userAvatar: string;
      userName: string;
      hasReward: boolean;
    }
  >('/app/activity/fission/getMyRewardRecord');
  return {
    reward: res.bonusAmount || 0,
    hasRank: res.hasRanking,
    hasReward: res.hasRanking,
    rank: res.ranking,
  };
}
